import { render, staticRenderFns } from "./Viewerheader.vue?vue&type=template&id=65f33ff7&"
import script from "./Viewerheader.vue?vue&type=script&lang=js&"
export * from "./Viewerheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports